import { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const b2bPayoutsStatusChoices = makeChoicesCommon<
  GetB2bCampaignsPayoutsOneResponse['status']
>()({
  pending: 'resources.bo_common.b2b.payouts.status.pending',
  completed: 'resources.bo_common.b2b.payouts.status.completed',
  cancelled: 'resources.bo_common.b2b.payouts.status.cancelled',
});
